import * as React from "react"

const SvgComponent = ((props: React.SVGProps<SVGSVGElement> )) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={350}
    height={400}
    viewBox="0 0 438 561"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" d="M0 0h431v493H0z" />
      <g fill="currentColor">
        <path d="m279.638 840.472 139.32-379.954s29.985-78.877-59.712-151.961-140.595 73.467-236.899 30.293c-162.066-79.452 85.006-219.865.612-304.928s-403.136 344.582-403.136 344.582Z" />
        <path
          d="M873.332-302.88s-151.089 40.858-270.943 133.037S378.935-49.51 393.916 65.837s120.966-.647 168.88 98.187c74.506 171.139-275.092-40.6-275.7 79.481S961.58 421.152 961.58 421.152Z"
          transform="rotate(135 288.849 140.61)"
          style={{
            mixBlendMode: "overlay",
            isolation: "isolate",
          }}
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent
